import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import { getAppColors } from './palette';

export * from './palette';

export function useAppColors() {
  const theme = useTheme();
  const mode = theme.palette.mode === 'dark' ? 'dark' : 'light';
  return useMemo(() => getAppColors(mode), [mode]);
}
